import React from "react";
import moment from "moment";

import ServingSizeIcon from "assets/icons/ServingSize.svg";
import CaloriesIcon from "assets/icons/Calories.svg";
import CorporateIcon from "assets/icons/Corporate.svg";
import PeopleIcon from "assets/icons/People.svg";
import CalendarIcon from "assets/icons/Calendar-grey.svg";
import SubmittedAtIcon from "assets/icons/Calendar-tick.svg";
import BreakfastIcon from "assets/icons/meal-breakfast-icon.svg";
import LunchIcon from "assets/icons/meal-lunch-icon.svg";
import SnackIcon from "assets/icons/meal-snack-icon.svg";
import DinnerIcon from "assets/icons/meal-dinner-icon.svg";

import FoodLogModal from "../Teleconsult/FoodLogModal";

export function MealList({ meals, getMeals }) {
  const MealType = (meal_type) => {
    switch (meal_type) {
      case "breakfast":
        return <img src={BreakfastIcon} alt="breakfast-icon" />;
      case "lunch":
        return <img src={LunchIcon} alt="lunch-icon" />;
      case "dinner":
        return <img src={DinnerIcon} alt="dinner-icon" />;
      default:
        return <img src={SnackIcon} alt="snack-icon" />;
    }
  };

  const CommentCountBadge = (n) => {
    if (n.has_new_comment === false) {
      return (
        <div className="badge comment-count read">
          {n.comment_count} Comments
        </div>
      );
    } else {
      return (
        <div className="badge  comment-count unread">
          ○ {n.comment_count} Comments
        </div>
      );
    }
  };

  return meals.map((n, i) => {
    return (
      <tr
        key={`meal-row-${i}`}
        className={`meal-row bg-white meal-row-${n.traffic_light_status}`}
      >
        <td className="d-table-cell py-6 pl-6 px-2 date">
          <div>
            <div className="font-size-11 fweight-500">
              {moment(n.date).format("DD MMM")}
            </div>
          </div>
        </td>
        <td className="d-table-cell px-2">
          <div className="vl"></div>
        </td>
        <td className="d-table-cell py-6 px-2 image">
          <img
            src={n.image_thumb}
            className="rounded"
            alt="user-meal"
            style={{ height: "90px", width: "90px" }}
          />
        </td>
        <td className="d-table-cell py-2 pr-6">
          <div className="container__text">
            <div className="food-log-row">
              <div>
                <FoodLogModal
                  props={n}
                  gender={n.gender}
                  user_id={n.user_id}
                  type="list"
                  getMeals={getMeals}
                ></FoodLogModal>
              </div>

              <div>{CommentCountBadge(n)}</div>

              {n.disable_ai_feedback && (
                <div className="badge askabe-disabled">AskAbe Disabled</div>
              )}
            </div>
          </div>

          <div>
            <div className="container__text">
              <div className="food-log-row">
                <div className="serving_size">
                  <img
                    src={ServingSizeIcon}
                    alt="serving-size-icon"
                    className="title-icon"
                  />
                  Serving Size: {n.serving_size} {n.serving_type || ""}
                </div>
                <div className="calories">
                  <img
                    src={CaloriesIcon}
                    alt="calories-icon"
                    className="title-icon"
                  />
                  {n.calories || 0} Calories
                </div>
                <div className="corporate">
                  <img
                    src={CorporateIcon}
                    alt="corporate-icon"
                    className="title-icon"
                  />
                  {n.corporate}
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="container__text">
              <div className="food-log-row">
                <div>
                  <img
                    src={PeopleIcon}
                    alt="people-icon"
                    className="title-icon"
                  />
                  {n.user_name}
                </div>
              </div>
            </div>
          </div>

          <div className="container__text">
            <div className="food-log-row">
              <div>
                <img
                  src={CalendarIcon}
                  alt="calendar-icon"
                  className="title-icon"
                />
                {moment(n.updated_at).format("DD/MM/YYYY HH:mm")} -{" "}
                {n.last_updated_by}
              </div>
              <div></div>

              <div>
                <img
                  src={SubmittedAtIcon}
                  alt="submitted-at-icon"
                  className="title-icon"
                />
                {moment(n.submitted_at).format("DD/MM/YYYY")}
              </div>
            </div>
          </div>
        </td>

        <td
          className="d-none d-xl-block d-lg-block d-md-block d-sm-none py-6"
          style={{ position: "relative" }}
        >
          <div className="meal-type"> {MealType(n.meal_type)}</div>
        </td>
      </tr>
    );
  });
}

export default MealList;
